import {
  LOGIN_FORM_CHANGED,
  LOG_OUT,
  IS_LOADING,
} from './accountActionsTypes';

const INITIAL_STATE = {
  initiated: true,
  isLoggedIn: false,
  isLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_FORM_CHANGED:
      return {
        ...state,
        [action.payload.prop]: action.payload.value,
      };
      case IS_LOADING:
        return {
          ...state,
          isLoading: action.payload,
        };
    case LOG_OUT:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return state;
  }
};
